import type { BasePageProps } from './BasePageProps';
import { Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import React from 'react';
import { theme } from '../theme';
import SEO from '@/shared/components/SEO';

const PageContainer = styled(Box)<{ embedded?: boolean }>`
  padding: ${props => props.embedded ? '16px 0' : '32px 24px'};
`;

const PageHeader = styled(Box)`
  margin-bottom: 24px;
`;

export function Page(props: BasePageProps) {
  const { icon, title, subtitle, embedded, forceHeader, children, description, action, actionHelperText } = props;
  const showHeader = !embedded || forceHeader;

  return (
    <>
      <SEO
        title={title ?? ''}
        description={description ?? ''}
        ogImage="https://app.kandir.io/kandir_logo.png"
        twitterImage="https://app.kandir.io/kandir_logo.png"
      />
      <PageContainer className="page-outer-container" data-embedded={embedded ? 'true' : 'false'}>
        {showHeader && (
          <PageHeader className="page-header">
            <Box className="page-title-wrapper" display="flex" justifyContent="space-between" alignItems="flex-start" mb={subtitle ? 1 : 0}>
              <Box className="page-title-container" display="flex" alignItems="center">
                {icon && (
                  <Box className="page-icon" sx={{ mr: 1 }}>
                    {React.createElement(icon)}
                  </Box>
                )}
                <Typography className="page-title" variant="h4">{title}</Typography>
              </Box>
              {action && (
                <Box className="page-action" display="flex" flexDirection="column" alignItems="flex-end">
                  {action}
                  {actionHelperText && (
                    <Typography
                      variant="caption"
                      sx={{
                        color: theme.palette.text.secondary,
                        mt: 0.5,
                        fontSize: '0.75rem',
                      }}
                    >
                      {actionHelperText}
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
            <Box
              sx={{
                width: 100,
                height: '4px',
                background: 'linear-gradient(135deg, #c05a3a, #d4825e)',
                mb: 2,
                borderRadius: '2px',
              }}
            />
            {subtitle && <Typography className="page-subtitle" variant="subtitle1" sx={{ color: theme.palette.text.secondary }}>{subtitle}</Typography>}
          </PageHeader>
        )}

        <Box className="page-body">
          {children}
        </Box>
      </PageContainer>
    </>
  );
}
